/* cSpell:disable */
import { Theme } from './types';
import { modalErrorImage, modalWarningImage, modalSuccessImage } from '../assets';

const defaultTheme: Theme = {
	image: {
		modalError: modalErrorImage,
		modalWarning: modalWarningImage,
		modalSuccess: modalSuccessImage,
	},
};

export default defaultTheme;
